<div class="experience-info-complete-container">

  <img alt="personal info complete" src="/img/experience-info-complete.png">

  <div class="text">
    <span [innerHTML]="'ExperienceInfoComplete.Title' | translate | safe:'html'"></span>
  </div>

</div>
